import React, { useEffect } from 'react';
import { useFlatDataList } from '../../../../Base/Hooks/useFlatDataList';
import {
	QuestionnaireResult,
	useQuestionnaireResultsWithScoringQuery,
} from '../../../../../graphql/graphql';
import { useAppContext } from '../../../../../Services/AppContext';
import styles from '../../../../Laboratory/Components/IssuedLaboratoryRequestsList/IssuedLaboratoryRequestsList.module.scss';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import FlatList from '../../../../Base/Components/FlatList';
import QuestionnaireResultsWithScoringListItem from './QuestionnaireResultsWithScoringListItem';

interface Props {
	questionnaireCode?: string;
}

const wrapperId = 'questionnaireResultsWithScoringListWrapper';

const QuestionnaireResultsWithScoringList: React.FC<Props> = ({
	questionnaireCode,
}) => {
	const { workplaceId } = useAppContext();
	const { flatData, pagination, getNextPage, appendData, updateItem, reset } =
		useFlatDataList<QuestionnaireResult>();

	const { data, isLoading, refetch, isFetching } =
		useQuestionnaireResultsWithScoringQuery({
			questionnaireCode,
			workplaceIds: [workplaceId],
			pagination,
		});

	useEffect(() => {
		appendData(
			(data?.questionnaireResults?.data as QuestionnaireResult[]) ?? [],
		);
	}, [data]);

	const refresh = () => {
		reset();
		refetch();
	};

	return (
		<div className={styles.wrapper}>
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={refetch}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading || isFetching}
					hasMoreData={data?.questionnaireResults?.meta?.hasNextPage || false}
					scrollableTargetId={wrapperId}
					renderItem={item => (
						<QuestionnaireResultsWithScoringListItem
							item={item}
							onSubmitScore={refresh}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default QuestionnaireResultsWithScoringList;
